import { Box, Button, CircularProgress, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import CodeIcon from "@mui/icons-material/Code";
import React, { useEffect, useState } from "react";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import { filterColArry } from "./data";
import { getColDefaultValue, isColumnDefault } from "components/EboStoreV4/data";
import { DownloadRounded } from "@mui/icons-material";
import { constraintsOptions, inputTypes, selectOptKeyName } from "data/globalData";
import FileSaver from "file-saver";
import axios from "axios";

const EboSale = () => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [loading, setLoading] = useState(false);
	const [filterColumns, setFilterColumns] = useState(filterColArry);

	const defaultData = filterColArry?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});

	const [filterData, setFilterData] = useState({ ...defaultData });

	const fetchDropdownValues = async () => {
		// api call to fetch dropdown values.
		setLoadingOpen(true);
		const body = {
			table: "adroit-standard-379209.MAYOOKH_THOR.EBO_SALES",
			columns: ["SEASON", "STATE", "BRAND", "SITECODE", "DIVISION"],
		};
		try {
			await axios.post("/api/custom_queries/get_dropdown_value", body).then((res) => {
				console.log("first res", res.data);
				// setDropdownValues(res.data);
				setFilterColumns((allColumns) => {
					let obj = res.data;
					return allColumns.map((row) => {
						if (obj[row.key] && [inputTypes.SELECT.key, inputTypes.MULTIPLE_SELECT.key].includes(row?.input_type)) {
							let opt = row[selectOptKeyName] ? row[selectOptKeyName] : {};
							opt = { ...opt, list: obj[row.key] };
							return { ...row, [selectOptKeyName]: opt };
						} else return row;
					});
				});
				setLoadingOpen(false);
			});
		} catch (error) {
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "unable to fetch values for dropdown",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};

	useEffect(() => {
		fetchDropdownValues();
	}, []);

	const handleRunQueryClick = async (e) => {
		e.preventDefault();
		setLoading(true);
		let pendingFields = [];
		filterColArry?.forEach((attr) => {
			if (isColumnDefault(attr, filterData?.[attr?.key]) && attr?.constraints?.[constraintsOptions.NOTNULL.key] === true)
				pendingFields.push(attr);
		});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
			return;
		}

		try {
			await pythonVmInstance({
				url: `/custom_queries/ebo_sale/download`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "post",
				responseType: "blob",
				data: {
					...filterData,
				},
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `EBO_SALE_${new Date().toISOString().split("T")[0]}.csv`);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Downloaded the file",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoading(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			console.log("asdfghjkl", error);
			setSnackBar({
				...snackBar,
				message: `failed to run query ${error}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
		}
	};

	return (
		<Stack spacing={2} component="form" onSubmit={handleRunQueryClick}>
			{/* <Typography variant="h6">All Channel Dispatch</Typography> */}
			{/* form */}
			<Box display="flex" columnGap={2} flexWrap={"wrap"} justifyContent={""} rowGap={2} pt={2}>
				{filterColumns?.map((col) => {
					return (
						<RenderInputField
							column={col}
							data={filterData}
							setData={setFilterData}
							selectOptObjName={"select_options"}
							width={"20%"}
							// selectOptObjName={selectOptKeyName}
							longWidth={"300px"}
							disabled={false}
							disableLabel={true}
						/>
					);
				})}

				<Box alignSelf="flex-end" pb={1}>
					<Button
						variant="contained"
						sx={{ width: "200px" }}
						type="submit"
						disabled={loading}
						startIcon={loading ? <CircularProgress color="inherit" size="20px" /> : <DownloadRounded />}>
						{loading ? "Loading..." : "Download"}
					</Button>
				</Box>
			</Box>
		</Stack>
	);
};

export default EboSale;
